import { ScanCard } from './ScanCard';
export default ScanCard;